import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Transaction from "./Transaction";
import OrderHistory from '../services/OrderHistory';
import { useEffect } from "react";
import { useLanguage } from './../common/LanguageContext'; 
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const Transactions = () => {
  const { t } = useTranslation();
  const location = useLocation();
const { language } = useLanguage();
const navigate = useNavigate();
const { serviceId } = location.state || {};
  const [transactionList, setTransactionList] = useState([
    
]);

const formatAmount = (value) => Number(value).toFixed(2);

  useEffect(() => {
  const fetchOrderHistory = async () => {
    try {
      const responseDataOrderHistory = await OrderHistory.orderHistoryDetails(
        `${language}`,
        serviceId
      );

      const formattedData = responseDataOrderHistory.map((data) => {
        // Dynamically set status from backend
        let status = "Pending";

        if (data.orderState) {
          switch (data.orderState.toUpperCase()) {
            case "CONFIRMED":
              status = "Confirmed";
              break;
            case "CANCELLED":
              status = "Cancelled";
              break;
            case "PENDING_FOR_INVOICE":
            case "PENDING_IRN":
            case "ORDER_REQUEST_PENDING_FOR_APPROVAL_FROM_ERP":
            case "ORDER_REQUEST_PENDING_FOR_APPROVAL_FROM_IRN":
              status = "Pending";
              break;
            default:
              status = data.orderState; // fallback: use raw value
          }
        }

        return {
          name: data.orderInfo?.SERVICE_NAME || "-",
          date: data.orderDate,
          status: status,
          amount: formatAmount(data.orderAmount),
          serviceId: data.serviceId,
        };
      });

      setTransactionList(formattedData);
    } catch (error) {
      console.error("Error fetching order History Details:", error);
    }
  };

  fetchOrderHistory();
}, [language, serviceId]);


 // Don't render Service Insights card if there's no data
 if (!transactionList || transactionList.length === 0) {
  return null;
}

  return (
  <div
    className="bg-white rounded shadow-sm w-auto mb-3"
    style={{ padding: "20px", marginTop: "20px" }}
  >
    <h2 className="h5 mb-3">{t("service_insights")}</h2>
    <ul
      className="list-unstyled"
      style={{
        maxHeight: "250px", // adjust based on your item height so ~5 items fit
        overflowY: "auto",
      }}
    >
      {transactionList.map((transaction, index) => (
        <Transaction
          key={index}
          name={transaction.name}
          amount={transaction.amount}
          date={transaction.date}
          status={transaction.status}
          serviceId={transaction.serviceId}
        />
      ))}
    </ul>
  </div>
);

};

export default Transactions;
